class animItemsOnScroll {
    constructor() {
        this.reset();
    }

	init() {
		setTimeout(() => {
			this.animOnScroll();
		}, 250);
	}

    animOnScroll() {
		for (let index = 0; index < this.animItems.length; index++) {
			let animItem = this.animItems[index];
			let animItemHeight = animItem.offsetHeight;
			let animItemOffSet = this.offset(animItem).top;
			const animStart = 7;
			let animItemPoint = window.innerHeight - animItemHeight / animStart;
			if (animItemHeight > window.innerHeight) {
				animItemPoint = window.innerHeight - window.innerHeight / animStart;
			}
			if (
				pageYOffset > animItemOffSet - animItemPoint &&
				pageYOffset < animItemOffSet + animItemHeight
			) {
				animItem.classList.add(`_anim-active`);
			}
		}
	}

	offset(el) {
		const rect = el.getBoundingClientRect();
		let scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
		let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
	}

	reset() {
		this.animItems = document.querySelectorAll(`.acf-block, .anim-on-scroll`);
	}
}

export default animItemsOnScroll;